import React, { useEffect } from 'react';
import { App } from 'antd';
import { useNavigate } from 'react-router-dom';

import { ProfileDeleteModal } from '../components/ProfileDeleteModal';
import { useDeleteAccountMutation } from '../../../services';
import { useApiErrorNotification } from '../../../../../hooks/useApiErrorNotification';

export const ProfileDeleteContainer = () => {
    const { notification } = App.useApp();
    const navigate = useNavigate();

    const [deleteAccount, { error, isError, isLoading, isSuccess }] =
        useDeleteAccountMutation();

    useEffect(() => {
        if (isSuccess) {
            notification.success({
                message: 'Аккаунт удален успешно',
                placement: 'top',
            });
            localStorage.removeItem('accessToken');
            navigate('/');
        }
    }, [isSuccess]);

    useApiErrorNotification(isError, error);

    const cancelDelete = () => {
        navigate(-1);
    };

    return (
        <ProfileDeleteModal
            onDelete={deleteAccount}
            onCancel={cancelDelete}
            loading={isLoading}
        />
    );
};
